import { z } from 'zod';

export const InputNumber = z.union([
  z.coerce.number(),
  z.string().transform((val) => (val === '' ? undefined : Number(val))),
]);
export type TInputNumber = z.infer<typeof InputNumber>;

export const DatePickerValue = z.date().nullable();
export type TDatePickerValue = z.infer<typeof DatePickerValue>;
